import { OverviewItems } from 'components/cases/common/Overview/Overview'
import { IssueSolutionItems } from 'components/cases/common/Overview/Overview'
import { CaseStudyItems } from 'components/cases/common/CaseStudy/CaseStudy'

// ファーストビュー
export const firstViewItem = {
  breadcrumb: 'コンタクトレンズが簡単注文できるアプリ',
  title1: 'コンタクトレンズが簡単注文できるアプリ',
  introduction_text:
    'コンタクトレンズを簡単に注文できるスマホアプリを開発いたしました。このアプリは、ユーザー体験に重点を置き、アプリを開いてすぐに購入できるような、PUSH通知からのシナリオを描いた導線設計やUI設計を行いました。弊社はウォークスルーのイラスト・アニメーションからアプリの開発まで実施しました。',
  company: '株式会社ビジョナリーホールディングス',
  tag1text: 'アプリケーション開発',
  tag1src: '/cases/application-development/',
  tag2text: 'UX/UI改善',
  tag2src: '/cases/uxui-improvement/',
  tag3text: 'ZEBRA',
  tag3src: '/cases/zebra/',
  industryTagText: '小売/流通/卸',
  industryTagSrc: '/cases/retail/',
  color: '',
  background: '#D2E1FF',
  staff1: '',
  image: '/images/img/cases/caseStudyTop/visionaryholdings.webp',
  alt: 'コンタクトレンズが簡単注文できるアプリ',
  imgClass: 'fv_img_adjust1',
}

// プロジェクト概要
export const overviewTitle = 'ビジネスから逆算した導線、UI設計のご支援'
export const overviewItem: OverviewItems[] = [
  {
    text: 'メガネスーパーのコンタクトレンズを簡単に注文できるアプリ。アプリを開いてすぐに購入できるような、PUSH通知からのシナリオを描いた導線設計やUI設計を行いました。ウォークスルーのイラスト・アニメーションまで作成しています。',
  },
]

// 課題と解決策
export const issueSolutionItems: IssueSolutionItems[] = [
  {
    issues: [
      {
        title: '新規顧客のリピートが少ない',
        text: '',
      },
      {
        title: '注文までの操作が複雑',
        text: '',
      },
      {
        title: 'アプリの体験が最適化されていない',
        text: '',
      },
    ],
    solutions: [
      {
        title: '顧客体験価値を向上させ、既存顧客への移行施策を実施',
        text: '',
      },
      {
        title: '煩雑な手順なく、アプリを開きすぐに購入できる導線の設計',
        text: '',
      },
      {
        title: 'PUSH通知からCVまでのシナリオを描いた導線やUIの設計',
        text: '',
      },
    ],
  },
]

// 関連事例
export const caseStudyItem: CaseStudyItems = [
  {
    projectName: '【技術系災害ボランティア体験】家屋再生〜水害編〜',
    client: '公益財団法人日本財団ボランティアセンター様',
    src: '/images/img/case/img_case_volunteer-ex.png',
    alt: '公益財団法人日本財団ボランティアセンター様',
    href: '#',
    tags: [{ name: 'XR/メタバース導入', url: 'xr' }],
  },
  {
    projectName: 'PEACH JOHN',
    client: '株式会社ピーチ・ジョン様',
    src: '/images/img/case/img_peachjohn.png',
    alt: '株式会社ピーチ・ジョン様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アプリケーション開発', url: 'application-development' },
      { name: '小売', url: 'service' },
    ],
  },
  {
    projectName: 'セブンネットショッピング「推し活倶楽部」',
    client: '株式会社セブンネットショッピング様',
    src: '/images/img/case/img_sevennet.png',
    alt: '株式会社セブンネットショッピング様',
    href: '#',
    tags: [
      { name: 'UX/UIデザイン', url: 'uiux' },
      { name: 'アーキテクチャ設計サービス', url: 'architecture-design' },
      { name: '小売', url: 'service' },
    ],
  },
]
